<template>
  <div class="dialog-list">
    <DialogPractice ref="practice" :dialogs="dialogs" @active="setActive"><template #language><slot name="language"></slot></template></DialogPractice>
    <slot name="title"></slot>
    <article v-for="(dialog, index) in dialogs" :key="index" class="dialog-row"
      :class="{'dialog-row-right': speakerIndex(dialog.name) % 2 !== 0, 'dialog-row-playing': activeDialog === index}">
      <div class="dialog-person">
        <div class="dialog-avatar" aria-hidden="true">{{ initials(dialog.name) }}</div>
        <div class="dialog-speaker" v-html="dialog.name"></div>
      </div>
      <div class="dialog-message" v-html="dialog.content"></div>
      <button v-if="isReadyAudioButton && dialog.audio" type="button" class="dialog-listen"
        :aria-label="speakerName(dialog.name) + (activeDialog === index ? ' — Durdur' : ' — Dinle')"
        :title="activeDialog === index ? 'Durdur' : 'Dinle'"
        :aria-pressed="activeDialog === index" @click="$refs.practice.playSingle(index)">
        <i :class="activeDialog === index ? 'bi bi-stop-fill' : 'bi bi-volume-up-fill'" aria-hidden="true"></i>
      </button>
    </article>
  </div>
</template>
<script>
import DialogPractice from './DialogPractice.vue';
export default {
  name: 'SubjectDialogContent',
  components: { DialogPractice },
  data() { return { activeDialog: null }; },
  props: {
    dialogs: { type: Array, default: () => [] },
    isReadyAudioButton: Boolean
  },
  computed: {
    speakers() { return [...new Set(this.dialogs.map(dialog => this.speakerName(dialog.name)))]; }
  },
  methods: {
    stop() { this.$refs.practice?.stop(); },
    setActive(index) {
      this.activeDialog = index;
      if (index != null) this.$nextTick(() => {
        this.$el.querySelectorAll('.dialog-row')[index]?.scrollIntoView?.({block: 'nearest', behavior: 'smooth'});
      });
    },
    speakerName(name) { return String(name || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim(); },
    speakerIndex(name) { return this.speakers.indexOf(this.speakerName(name)); },
    initials(name) {
      return this.speakerName(name).split(/\s+/).filter(Boolean).slice(0, 2).map(word => [...word][0]).join('').toLocaleUpperCase('tr-TR') || '?';
    }
  }
};
</script>
<style scoped>
.dialog-list { display: flex; flex-direction: column; gap: 24px; margin-top: 24px; }
.dialog-row { --bubble: #fff0e1; --accent: #a54d0a; display: flex; align-items: center; gap: 14px; width: 100%; }
.dialog-row-right { --bubble: #e7f4e8; --accent: #26713b; flex-direction: row-reverse; }
.dialog-person { flex: 0 0 64px; align-self: flex-start; text-align: center; }
.dialog-avatar { display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; margin: 0 auto 5px; border-radius: 50%; background: #deedf6; color: #365c76; border: 3px solid white; box-shadow: 0 0 0 1px #e2e8f0; font-size: 15px; font-weight: 700; }
.dialog-row-right .dialog-avatar { background: #dcefe9; color: #326656; }
.dialog-speaker { color: #475569; font-size: 12px; font-weight: 600; line-height: 1.4; overflow-wrap: anywhere; }
.dialog-speaker :deep(p) { margin: 0; }
.dialog-message { position: relative; max-width: 72%; min-width: 0; padding: 14px 18px; border-radius: 14px; background: var(--bubble); color: #334155; font-size: 16px; line-height: 1.7; overflow-wrap: anywhere; }
.dialog-message::before { content: ''; position: absolute; top: 18px; left: -7px; width: 14px; height: 14px; background: var(--bubble); transform: rotate(45deg); border-radius: 2px; }
.dialog-row-right .dialog-message::before { left: auto; right: -7px; }
.dialog-message :deep(p) { position: relative; margin-bottom: .75em; }
.dialog-message :deep(p:last-child) { margin-bottom: 0; }
.dialog-message :deep(img) { max-width: 100%; height: auto; }
.dialog-row-playing .dialog-message { box-shadow: inset 0 0 0 2px var(--accent); }
.dialog-listen { display: inline-flex; align-items: center; justify-content: center; flex: 0 0 40px; width: 40px; height: 40px; border: 1px solid transparent; border-radius: 50%; background: var(--bubble); color: var(--accent); font-size: 19px; }
.dialog-listen:hover { border-color: var(--accent); }
.dialog-listen[aria-pressed="true"] { background: var(--accent); color: white; }
.dialog-listen:focus-visible { outline: 3px solid var(--accent); outline-offset: 3px; }
@media (max-width: 575px) {
  .dialog-list { gap: 20px; }
  .dialog-row { gap: 10px; }
  .dialog-person { flex-basis: 44px; }
  .dialog-avatar { width: 36px; height: 36px; font-size: 12px; }
  .dialog-speaker { font-size: 11px; }
  .dialog-message { max-width: none; flex: 1; padding: 12px; font-size: 15px; }
  .dialog-listen { flex-basis: 36px; width: 36px; height: 36px; font-size: 17px; }
}
</style>
